export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5040.9f950e1c.jpg";